import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { CONFIG } from 'src/config-global';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';
import { AdminGuard } from 'src/auth/guard/admin-guard';
import { CompanyGuard } from 'src/auth/guard/company-guard';
import { EmployeeGuard } from 'src/auth/guard/employee-guard';

// ----------------------------------------------------------------------

const ClientsPage = lazy(() => import('src/pages/clients'));
const ClientDetailsPage = lazy(() => import('src/pages/clients/details'))

// ----------------------------------------------------------------------

const layoutContent = (
  <DashboardLayout>
    <Suspense fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  </DashboardLayout>
);

export const clientsRoutes = [
  {
    path: 'clients',
    element: CONFIG.auth.skip
      ? <>{layoutContent}</>
      : <AuthGuard>
        <CompanyGuard>
          <EmployeeGuard>
            {layoutContent}
          </EmployeeGuard>
        </CompanyGuard>
      </AuthGuard>,
    children: [
      { element: <AdminGuard><ClientsPage /></AdminGuard>, index: true },
      { path: ':id/details', element: <AdminGuard><ClientDetailsPage /></AdminGuard> }
    ],
  },
];
